import React, { useEffect, useMemo, useRef, useState } from 'react'
import RightSideDetails from "../global/rightSideDetails";
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import Select from 'react-select';
import { deleteMatBook, getMatBook,  getMatMasterAll, getMatTemplateByMasterID, getRangeFeeMasterByDate, getRangeTypeAll, postMatBook } from '../api/matAPI';
import { getActiveGuest, getCoachTaggingByDate, getGolfUsers, getGuestAll, getSubCategoryMasterAll } from '../api/usersAPI';
import { getSettlementMasterAll } from '../api/teeTimeAPI';
import AddGuest from '../teeTime/addGuest';
import AddGSTNumber from '../teeTime/addGSTNumber';
import moment from 'moment';
import {serverDate} from '../../assets/scripts/periodSelection';

const webURL = window.location.host.indexOf('localhost') >= 0 ? 'http://localhost:3000' : 'https://dev-ogr.golfez.in';

const MatBookingSheet = (props) => {

    const [isInit,                  setIsInit]                      = useState(true);
    const [rightSideDetails,        setRightSideDetails]            = useState(false);
    const [selectedDate,            setSelectedDate]                = useState(moment(serverDate).format('DD-MM-YYYY'));
    const [selectedMat,             setSelectedMat]                 = useState(null);
    const [filterdMaster,           setFilterdMaster]               = useState([]);
    const [allMaster,               setAllMaster]                   = useState([]);
    const [bookSheetList,           setBookSheetList]               = useState([]);
    const [bookSheet,               setBookSheet]                   = useState({Discount: 0, Bucket: 1, Type: "Member"});
    // const [usersList,               setUsersList]                   = useState([]);
    const [bookingTable,            setBookingTable]                = useState(null);
    const [holiday,                 setHoliday]                     = useState(null);
    const [courseClosed,            setCourseClosed]                = useState(null);
    const [serverTime,              setserverTime]                  = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
    const [bucketOption,            setBucketOption]                = useState([{ value:  1, label: 1}, { value:  2, label: 2}]);
    const [selectedType,            setSelectedType]                = useState({});
    const [selectedCloseType,       setSelectedCloseType]           = useState({});
    const [allTimeMaster,           setAllTimeMaster]               = useState([]);
    const [typeOption,              setTypeOption]                  = useState([{ value:  'Member', label: 'Member'}, { value:  'Guest', label: 'Guest'},]);
    // const [guestList,               setGuestList]                   = useState([]);
    const [filteredguestList,       setFilteredGuestList]           = useState([]);
    const [bookingUser,             setBookingUser]                 = useState(null);
    const [membershipCategory,      setMembershipCategoryOption]    = useState([]);
    const [settlementList,          setSettlementList]              = useState([]);
    const [rangeFeeMasterList,      setRangeFeeMasterList]          = useState([]);
    const [coachTaggingList,        setCoachTaggingList]            = useState([]);
    const [subCatID,                setSubCatID]                    = useState(null);
    const [guestUserID,             setGuestUserID]                 = useState(null);
    const [rateDetails,             setRateDetails]                 = useState({GreenFee : 0, Bucket: 0, Club: 0, Discount: 0, Cgst : 0, Sgst : 0, Total : 0});
    const [showAddGuest,            setShowAddGuest]                = useState(false);
    const [company,                 setCompany]                     = useState(null);
    const [selectCompany,           setSelectCompany]               = useState(null);
    const [matTemplate,             setMatTemplate]                 = useState([]);
    const [isValid,                 setIsValid]                     = useState(true);
    const [selectedUser,            setSelectedUser]                = useState(null);
    const [selectedGuest,           setSelectedGuest]               = useState(null);
    const [filteredList,            setFilteredList]                           = useState(null);

    const usersListRef = useRef([]);
    const guestListRef = useRef([]);
    
    
    // filter for users
    // const dataList = bookSheet?.SubCategoryID === 8 ? coachTaggingList : usersList;
    // const dataList = useMemo(() => 
    //     bookSheet?.SubCategoryID === 8 ? coachTaggingList : usersList,
    //     [bookSheet?.SubCategoryID, coachTaggingList, usersList]
    // );
    const dataList = useMemo(() => 
        bookSheet?.SubCategoryID === 8 ? coachTaggingList : usersListRef.current,
        [bookSheet?.SubCategoryID, coachTaggingList, usersListRef.current]
    );

    useEffect(() => {
        props.title("Range Booking Sheet", "mat-sheet");
        $('#txtDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtDate').on('change', function (event) {
            setSelectedDate(event.target.value)
        });   
        
        async function load() {
            await Promise.all([
                fetchSubCategoryMaster(),
                fetchSettlementMaster(),
                fetchUsers(),
                fetchGuest()
            ]);
        }

        load();

        return () => {
            $('#txtDate').off('change');
            if ($('#tblBookSheet').KTDatatable()) {
                $('#tblBookSheet').KTDatatable().destroy();
            }
        };
    }, []);
    // let selectedUser = dataList.find(m => m.ID == guestUserID);

    // filter for guest
    useEffect(() => {
        const filtered = guestUserID != null ? filteredguestList.filter(f => f.RefID == guestUserID) : filteredguestList;
        setFilteredList(filtered);
        // Find selected user only once
        if (bookSheet?.UserID) {
            const selectedG = filteredguestList.find(m => m.ID == bookSheet.UserID);
            setSelectedGuest(selectedG || null);
        } else {
            setSelectedGuest( null);
        }
    },[filteredguestList,guestUserID])

    useEffect(() => {
        fetchRangeTypeAndMatAll();
    }, [selectedDate]);

    const fetchRangeTypeAndMatAll = async () => {
        try {
            const calendarAll = await getRangeTypeAll();
            const activeCalendar = calendarAll.filter(item => item.Active == 'Y');
            const matAll = await getMatMasterAll();
            const activeMat = matAll.filter(item => item.Active === 'Y');
            setAllTimeMaster(activeCalendar);
            setAllMaster(activeMat); 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message })
        }
    };

    useEffect(() => {
        if (guestUserID && dataList.length > 0) {
            let user;
            if(subCatID == 8)
                user = dataList.find(m => m.UserID == guestUserID);
            else
                user = dataList.find(m => m.ID == guestUserID);

            setSelectedUser(user);
        } else {
            setSelectedUser(null);
        }
    }, [guestUserID, dataList]);
    
    useEffect(() => {
        if (selectedDate && selectedMat) {
            fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID)
            fetchRangeFeeMasterByDate(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
            fetchCoachTaggingByDate(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }
    }, [selectedMat]);
 
    useEffect(() => {
        const defaultCalender = allTimeMaster?.length > 0 ? allTimeMaster[0] : {};
        if (!defaultCalender?.ID) return;
        setSelectedType(defaultCalender)
    }, [allMaster]);
 
    useEffect(() => {
        if (selectedType?.ID && allMaster.length > 0) {
            const filtMat = allMaster.filter(f => f.TypeID === selectedType.ID);
            if (filtMat.length > 0) {
                setBookSheet(a => ({...a, MatID: filtMat[0].ID}))
                setSelectedMat(filtMat[0]);
                setFilterdMaster(filtMat);
            }
        }
    }, [selectedType]);

    useEffect(() => {  
        if(rightSideDetails){
            Config.Core.OpenDrawer()
        }else{
            setSelectedType(selectedCloseType)
            setBookSheet({})
            setBookingUser(null)
            setIsValid(true)
            setSelectCompany(null)
            setShowAddGuest(false)
            clearRates()
        }
    }, [rightSideDetails]);

    useEffect(() => {  
        if (!isInit) fillDataTable();
    }, [bookSheetList, holiday, serverTime]);

    useEffect(() => {
        if(subCatID != null) {
            calculateTotalWithTaxes(subCatID)
        }
        if(bookSheet?.SubCategoryID){
            const filtGuest = guestListRef.current.filter((f) => f.SubCategoryID == bookSheet.SubCategoryID);
            setFilteredGuestList(filtGuest);
        }
    }, [subCatID, bookSheet])

    const resetUser = () => {
        setBookSheet(a => ({...a, UserID: ''}))
        setBookingUser(null)
        clearRates()
    }

    const updateBookingDetails = (field, value) => { 
        setBookSheet((d) => {
            return { ...d, [field]: value };
        });
    };

    const fetchBookSheet = async (selectedDate, dayName, matID) => {
        try {
            if(!selectedDate || !dayName || !matID) return;
            const response = await getMatBook({selectedDate, dayName, matID, type: 'matBookSheet'});
            isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
            setBookSheetList(response.bookSheet);
            setHoliday(response.holiday);
            setCourseClosed(response.courseClosed);
            setserverTime(response.serverTimestamp);
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message })
        }
    };

    const fetchRangeFeeMasterByDate = async (date) => {
        try {
            const master = await getRangeFeeMasterByDate(date);
            setRangeFeeMasterList(master); 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message });
        }
    };

    const fetchCoachTaggingByDate = async (date) => {
        try {
            const users = await getCoachTaggingByDate(date);
            setCoachTaggingList(users); 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message });
        }
    };


    const fetchSubCategoryMaster = async() =>{
        try {
            const response = await getSubCategoryMasterAll();
            const filteredCategory = response.filter((f) => f.CategoryID == 2 && f.ID != 6 && f.Active == "Y")
            setMembershipCategoryOption(filteredCategory);             
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    };

    const fetchSettlementMaster = async () => {
        try {
            const master = await getSettlementMasterAll(); // Adjusted this to get the settlement data
            setSettlementList(master);
        } catch (error) {
            swal.fire({
                icon: 'error',
                titleText: error.message
            })
        }
    };
        
    const fetchUsers = async () => {
        try {
            const users = await getGolfUsers('user');
            // setUsersList(users);
            usersListRef.current = users; 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message })
        }
    }
        
    const fetchGuest = async () => {
        try {
            const guest = await getActiveGuest();
            // setGuestList(guest);
            guestListRef.current = guest; 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message })
        }
    };

    const fetchMatTemplateByMasterID = async (id) => {
        try { 
            const response = await getMatTemplateByMasterID(id)
            setMatTemplate(response);    
            swal.close()
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }

    const calculateTotalWithTaxes = (subCatID) => {
        const filtrFee = rangeFeeMasterList?.find(f => 
            f.SubCategoryID == subCatID && 
            f.Type == selectedType.Type && 
            f.IsWeekend == bookSheet.IsWeekend
        );

        if (!filtrFee) return null; // Return null if no matching fee is found
    
        let total = 0;    
        let bucket;
        let club;
        let discountAmount;

        // Apply Bucket multiplier for Bucket
        total = filtrFee.Bucket * bookSheet.Bucket;
        bucket = filtrFee.Bucket * bookSheet.Bucket
    
        // Apply Club charge if Club is 'Y'
        if (bookSheet.Club == 1) {
            total += filtrFee.Club;
            club = filtrFee.Club
        }
    
        total += filtrFee.GreenFee
        // Apply Discount (Assuming Discount is a percentage, e.g., 10 for 10%)
        if (bookSheet.Discount > 0) {
            discountAmount = (total * bookSheet.Discount) / 100;
            total -= discountAmount;
        }else{
            discountAmount = 0
        }
        // Calculate CGST and SGST at 9% each
        const cgst = total * 0.09;
        const sgst = total * 0.09;
    
        // Calculate the final total including taxes
        const finalTotal = total + cgst + sgst ;
    
        // Create an object to store the breakdown and total
        const result = {
            GreenFee: filtrFee.GreenFee,
            Club: club,
            Bucket: bucket,
            Discount: discountAmount,
            Cgst: subCatID == 2 ? cgst.toFixed(2) : Math.round(cgst),
            Sgst: subCatID == 2 ? cgst.toFixed(2) : Math.round(sgst),
            Total: Math.round(finalTotal),
        };
        setRateDetails(result); // Update the state with the calculated details
    }; 

    const cancelBookingHandler = async (d) => {
        const btn = $('#btnCancel');
        helper.StartProcessing(btn);
        const swalResult = await swal.fire({
            title               : 'Are you sure?',
            text                : "You won't be able to revert this!",
            icon                : 'warning',
            showCancelButton    : true,
            buttonsStyling      : false,
            reverseButtons      : true,
            showLoaderOnConfirm : true,
            confirmButtonClass  : 'btn btn-brand',
            cancelButtonClass   : 'btn btn-secondary',
            confirmButtonText   : 'Delete',
            preConfirm: async () => {
              try {
                await deleteMatBook(bookSheet.ID, bookSheet.Comment)

              } catch (err) {
                helper.StopProcessing(btn);
                swal.fire({
                  icon                : 'error',
                  titleText           : 'Error!',
                  text                : err.message,
                  buttonsStyling      : false,
                  confirmButtonClass  : 'btn btn-brand',
                });
                return;
              }
            },
        });
        if (!swalResult.value) return;
        helper.StopProcessing(btn);
        fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID) 
        closeDrawer();
        swal.fire({
            icon: 'success',
            titleText: 'Booking deleted successfully!',
            showConfirmButton: false,
            timer: 1500,
        });
    }
    
    const viewForm = () => {
        // window.open(`http://localhost:3001/invoice?id=${bookSheet.TransactionID}`, '_blank', 'noopener');
        window.open(`${webURL}/invoice?id=${bookSheet.TransactionID}`, '_blank', 'noopener');
    };

    const addBookingHandler = async () => {
        const btn = $('#btnSave');
        if (bookSheet.Bucket == 0 || !bookSheet.Bucket) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Enter number of Bucket",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }
        if (bookingUser == null || Object.keys(bookingUser).length === 0) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Please select player",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }
    
        helper.StartProcessing(btn);
        try {
            await postMatBook({
                ...bookSheet,
                OwnerID     : bookSheet.OwnerID || 0,
                ID          : bookSheet?.ID || 0,
                MatID       : bookSheet?.MatID ||selectedMat.ID,
                OwnerType   : "Admin",
                CompanyID   : selectCompany?.ID || 0,
                Discount    : bookSheet?.Discount || 0,
                Type        : 'Mat',
                UserType    : bookSheet?.UserType || bookingUser?.UserType,
                BookDate    : moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), 
            })
            if (bookSheet?.ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Booking updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20',
                    },
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Booking added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            closeDrawer();
            fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID)
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }

    }

    const validateBucket = (field, value) => {
        if (value > 5)
            value = 5;

        if (value < 0)
            value = 1

        // if (value = 0)
        //     value = 1
        updateBookingDetails(field, value)
    }

    const closeDrawer = () =>{
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
        }, 200);
    }

    const addBookingUserHandler = (type) => {
        if(bookSheet.UserID) {
            let newO;
            if (type == "user") {
                newO = { ...usersListRef.current.find((f) => f.ID == bookSheet.UserID), UserType: 'User' }
                setBookingUser(newO);
            }
            else {
                newO = { ...filteredguestList.find((f) => f.ID == bookSheet.UserID), UserType: 'Guest' }
                setBookingUser(newO);
            }
        }
    }

    function exportSheet(btnType) {
        let fileName = `${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - Mat Booking Sheet`;
        

        bookingTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });
        
        if (btnType == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        
        $('.tableexport-caption').addClass('hidden');
    }

    function fillDataTable() {
        swal.close();
        if (holiday != null) {
            $('#lblHoliday').text("Holiday : " + holiday.Name);
        }else if (courseClosed != null) {
            $('#lblHoliday').text("CourseClosed : " + courseClosed.Name);
        }else {
            $('#lblHoliday').text("");
        }

        const dataTable = $('#tblBookSheet').KTDatatable({
            data: {
                saveState: false,
                source   : bookSheetList,
                pageSize : 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable  : true,
            pagination: true,
            search    : { input: $('#generalSearch')},
            columns: [               
                {  field: 'Slot',  title: 'Slot',
                    template: function (row) {
                        return `${row.SlotFrom} To ${row.SlotTo}`
                    },
                    width:250 
                },
                {
                    field: 'Status',
                    title: 'Status',
                    template: function (row) {
                        if (row.Status != null) {
                            return `<span class="badge badge-danger">${row.Status}</span>`
                        } else {
                            return '<span class="badge badge-success"> Available </span>'
                        }
                    },
                    width: 120,
                },
                {
                    field: 'UserName',
                    title: 'Player',
                    width: 120,
                },
                {
                    field: 'TrackingID',
                    title: 'Tracking ID',
                    width: 120,
                },
                {
                    field: 'PGAmount',
                    title: 'Bill Amt',
                    width: 120,
                },
                {
                    field: 'Bucket',
                    title: ' Bucket',
                    width: 65,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ${row?.UserID != 0 ? !!row?.Bucket ? row?.Bucket : '' : ''}</strong>`
                    }
                },
                {
                    field: 'Club',
                    title: 'Club',
                    width: 55,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ${row?.UserID != 0 ? (row?.Club == 1 ? 'Yes' : !!row?.Bucket ? 'No' : '') : ''}</strong>`
                    }
                },
                {
                    field: 'Comment',
                    title: 'Comment',
                    width: 120,
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    class: "clickable",
                    template: function (row) {

                        if ((row.Status == "Booked" || row.Status == null)) {
                            return showEditButton(row)
                        } else {
                            return '';
                        }
                    }
                },
            ],
            rows: {
                autoHide: false,
            }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        // export to excel
        const BookingTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Mat Booking Sheet`,
        });
        setBookingTable(BookingTable);
        $('.tableexport-caption').addClass('hidden');
        
        function showEditButton(row) {

            const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');

            var optString = '';

            const isEdit = true;
            // const isEdit = moment(moment(serverTime.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);

            optString += '<center>'

            if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`

            if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`

            optString += '</center>'

            return optString;
        }

        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                setBookSheet({
                    ...dataTable.dataSet[index], 
                    Bucket      : dataTable.dataSet[index].Bucket ? dataTable.dataSet[index].Bucket : 1,
                    Discount    : dataTable.dataSet[index].Discount === 0 ? 0 : dataTable.dataSet[index].Discount,
                    Club        : dataTable.dataSet[index]?.Club || 0,
                    Type        : dataTable.dataSet[index]?.UserType == "Guest" ? "Guest" : "Member",
                })
                setSelectedCloseType(selectedType)
                fetchMatTemplateByMasterID(dataTable.dataSet[index]?.MatTimeMasterID)
                let formattedDate = moment(selectedDate, 'DD-MM-YYYY').format('DD-MMM-YYYY')
                let selectedDay = moment(formattedDate + ' ' + dataTable.dataSet[index].SlotFrom).format("MM/DD/YYYY hh:mm A");
                let currentDate = moment().format("MM/DD/YYYY hh:mm A");
              
                if (moment(currentDate).isSameOrAfter(moment(selectedDay)) && dataTable.dataSet[index]?.ID) setIsValid(false)

                if(dataTable.dataSet[index]?.ID){
                    if (dataTable.dataSet[index].UserType == "User") {
                        const scID = usersListRef.current.find(f => f.ID == dataTable.dataSet[index].UserID)
                        const id = isValidMember(scID?.SubscriptionExpiresOn, scID?.MembershipExpiresOn, moment(selectedDate, 'DD-MM-YYYY').format('DD-MMM-YYYY')) ? 3 : scID?.SubCategoryID
                        setSubCatID(id)
                    } else {
                        const scID = guestListRef.current.find(f => f.ID == dataTable.dataSet[index].UserID).SubCategoryID
                        setSubCatID(scID)
                    }
                    if(dataTable.dataSet[index].OwnerID != 0) setGuestUserID(dataTable.dataSet[index].OwnerID)
                    if(dataTable.dataSet[index]?.CompanyID != 0) setSelectCompany({ID: dataTable.dataSet[index]?.CompanyID, CompanyName: dataTable.dataSet[index]?.CompanyName, GSTNumber: dataTable.dataSet[index]?.GSTNumber})
                    setBookingUser({Name: dataTable.dataSet[index].UserName, UserType: dataTable.dataSet[index].UserType })
                }
               
                setRightSideDetails(true); 
                
            } 
        });
    };

    const deleteUserHandler = () => {
        setBookingUser(null)
        setSelectedGuest(null)
        setBookSheet({...bookSheet, 'UserID': null})
        clearRates();
    }

    const clearRates = () => {
        setSubCatID(null)
        setRateDetails({Bucket: 0, Club: 0, Discount: 0, Cgst : 0, Sgst : 0, Total : 0})
    }

    const isValidMember = (SubscriptionExpiresOn, MembershipExpiresOn, BookDate) => {
        const getMomentDate = (date) => (date ? moment(date) : null);
    
        const subscriptionExpiresOn = getMomentDate(SubscriptionExpiresOn);
        const membershipExpiresOn = getMomentDate(MembershipExpiresOn);
        const bookDate = getMomentDate(BookDate); 
        return (
            (subscriptionExpiresOn && subscriptionExpiresOn.isValid() && subscriptionExpiresOn.isBefore(bookDate)) ||
            (membershipExpiresOn && membershipExpiresOn.isValid() && membershipExpiresOn.isBefore(moment()))
        );
    };
    

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content" >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">Date </label>
                                    <div className="form-group col-xs-2 col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtDate" 
                                                name="txtDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date"
                                                defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            /> 
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">Type </label>
                                    <div className="form-group col-xl-2 col-sm-2">
                                        <Select
                                            onChange={(event) => setSelectedType({ID: event.value, Type: event.type})}
                                            name="ddlSelectType"
                                            value={(selectedType.ID && allTimeMaster.length > 0) && {label : allTimeMaster.find(f => f.ID == selectedType?.ID)?.Name, value: selectedType?.ID}}
                                            id="ddlSelectType"
                                            className="ddlSelectType"
                                            options={allTimeMaster.map(c => ({
                                                label: c.Name,
                                                value: c.ID,
                                                type:  c.Type
                                            }))}
                                        />
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">Mat </label>
                                    <div className="form-group col-xl-2 col-sm-2">
                                        <Select
                                            onChange={(event) => setSelectedMat(event.value)}
                                            name="ddlSelectUser"
                                            value={(selectedMat && (filterdMaster && filterdMaster.length > 0)) && {label : selectedMat.Number, value: selectedMat}}
                                            id="ddlSelectUser"
                                            className="ddlSelectUser"
                                            options={filterdMaster.map(c => ({
                                                label: `${c.Number}`,
                                                value: c
                                            }))}
                                        />
                                    </div>
                                    <div className="form-group col-xl-2 col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-1 col-sm-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('xlsx')}
                                                >Excel
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('csv')}
                                                >Csv 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 id="lblHoliday" className="lblHoliday"></h5>
                            <div id="tblBookSheet" className="table table-bordered table-hover custom-datatable"></div>
                            {rightSideDetails && 
                                <RightSideDetails title="Booking Sheet" onCloseDrawer={closeDrawer}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form id="ModalHolder" className="kt-form kt-form--label-right padding-10">
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Date</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblDate" 
                                                            disabled="disabled" 
                                                            name="lblDate" 
                                                            type="text" 
                                                            className="form-control"
                                                            value={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                        />
                                                    </div>
                                                </div> 
                                                {!!bookSheet?.ID && (
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Type</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <Select
                                                                onChange={(event) => setSelectedType({ID: event.value, Type: event.type})}
                                                                name="ddlSelectRangeTypeID"
                                                                disabled={!bookSheet.ID && "disabled" }
                                                                value={(selectedType.ID  && allTimeMaster.length > 0) && {label : allTimeMaster.find(f => f.ID == selectedType.ID )?.Name, value: selectedType.ID }}
                                                                id="ddlSelectRangeTypeID"
                                                                className="ddlSelectRangeTypeID"
                                                                options={allTimeMaster.filter(f => f.Type == selectedType.Type).map(c => ({
                                                                    label: c.Name,
                                                                    value: c.ID, 
                                                                    type:  c.Type

                                                                }))}
                                                            />
                                                        </div>
                                                    </div> 
                                                )}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Way</label>
                                                    <div className="col-xl-6 col-lg-8"> 
                                                        <Select
                                                            onChange={(event) => updateBookingDetails('MatID', event.value)}
                                                            name="ddlSelectMatID"
                                                            isDisabled={bookSheet.ID == 0? "disabled" : ''}
                                                            value={(bookSheet.MatID && (allMaster && allMaster.length > 0)) && {label : allMaster.find(f => f.ID == bookSheet?.MatID)?.Number, value: bookSheet.MatID} || {label : selectedMat.Number, value: selectedMat}}
                                                            id="ddlSelectMatID"
                                                            className="ddlSelectMatID"
                                                            options={filterdMaster.map(c => ({
                                                                label: `${c.Number}`,
                                                                value:  c.ID
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlSlot" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Slots</label>
                                                    <div className="col-xl-6 col-lg-8"> 
                                                        <Select
                                                            onChange={(event) => updateBookingDetails('TemplateID', event.value)}
                                                            name="ddlSelectSlot"
                                                            isDisabled={bookSheet.ID == 0? "disabled" : ''}
                                                            value={(bookSheet?.TemplateID && (matTemplate && matTemplate.length > 0)) && {label : `${matTemplate.find(f => f.ID == bookSheet?.TemplateID)?.SlotFrom} To ${matTemplate.find(f => f.ID == bookSheet?.TemplateID)?.SlotTo}`, value: bookSheet.TemplateID} || ''}
                                                            id="ddlSelectSlot"
                                                            className="ddlSelectSlot"
                                                            options={matTemplate.map(c => ({
                                                                label: `${c.SlotFrom} To ${c.SlotTo}`,
                                                                value:  c.ID
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlType" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Category <span className="red"></span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div>
                                                            <Select 
                                                                id="ddlType" 
                                                                name="ddlType"
                                                                className="multi-custom"
                                                                isDisabled={bookingUser ? true : false}
                                                                placeholder="Select Category"
                                                                defaultValue={bookSheet?.Type ?  typeOption.find((m) => m.value == bookSheet?.Type ) : '' }
                                                                onChange={(event) => {updateBookingDetails('Type', event.value), updateBookingDetails('UserID', ''), clearRates()}}
                                                                options={typeOption}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {bookSheet.Type == "Member" ? (
                                                    <div id="UserHolder">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">Member</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group" >
                                                                    <div style={{width: "60%"}}  >
                                                                        <Select
                                                                            value={(usersListRef && usersListRef.current.length > 0 && bookSheet.UserID) && {label: `${usersListRef.current.find(m => m.ID == bookSheet.UserID)?.Name} (${usersListRef.current.find(m => m.ID == bookSheet.UserID)?.MembershipNo})`, value: bookSheet.UserID} || ''}
                                                                            onChange={(event) => {updateBookingDetails('UserID', event.value), setSubCatID(isValidMember(event.SubscriptionExpiresOn, event.MembershipExpiresOn, moment(selectedDate, 'DD-MM-YYYY').format('DD-MMM-YYYY')) ? 3 :  event.subCatID)}}
                                                                            name="ddlUser"
                                                                            isDisabled={bookingUser ? true : false}
                                                                            placeholder="Select User"
                                                                            id="ddlUser"
                                                                            className="ddlUser"
                                                                            options={usersListRef.current.map(c => ({
                                                                                label: `${c.Name} (${c.MembershipNo})`,
                                                                                value: c.ID,
                                                                                subCatID: c.SubCategoryID,
                                                                                SubscriptionExpiresOn: c.SubscriptionExpiresOn,
                                                                                MembershipExpiresOn: c.MembershipExpiresOn,
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                    <div className="input-group-append" style={{zIndex: 0}}>
                                                                        <button className="btn btn-secondary kt-select-reset" type="button" disabled={!!bookingUser} onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                    </div>
                                                                    {!bookingUser && (
                                                                        <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={() => addBookingUserHandler("user")}>Add</button>
                                                                    )}                                                                
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">SubCategory <span className="red">*</span></label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <Select 
                                                                    id="ddlSubCategoryID" 
                                                                    name="ddlSubCategoryID"
                                                                    className="multi-custom"
                                                                    placeholder="Select Category"
                                                                    isDisabled={bookingUser ? true : false}
                                                                    value={bookSheet?.SubCategoryID && membershipCategory.length > 0 && {label:  membershipCategory.find((m) => m.ID == bookSheet.SubCategoryID)?.Name, value: bookSheet.SubCategoryID}  || ''}
                                                                    onChange={(event) => {updateBookingDetails('SubCategoryID', event.value), clearRates(), updateBookingDetails('UserID', ''), setGuestUserID(null)}}
                                                                    options={membershipCategory.map(a => ({
                                                                        label: a.Name,
                                                                        value: a.ID,
                                                                    }))}
                                                                /> 
                                                            </div>
                                                        </div>
                                                        {bookSheet?.SubCategoryID && (
                                                            <>
                                                            {(bookSheet.SubCategoryID == 5 || bookSheet.SubCategoryID == 8) && (
                                                                <div id="UserHolder">
                                                                    <div className="form-group row">
                                                                        <label className="col-form-label col-lg-3">Member</label>
                                                                        <div className="col-xl-6 col-lg-8">
                                                                            <div className="input-group" >
                                                                                <div style={{width: "60%"}}  >
                                                                                <Select
                                                                                    value={selectedUser ? { 
                                                                                        label: `${selectedUser.Name} (${selectedUser?.MembershipNo})`, 
                                                                                        value: guestUserID 
                                                                                    } : ''}
                                                                                    onChange={(event) => { setGuestUserID(event.value),  updateBookingDetails('UserID', '') }}
                                                                                    name="ddlUser"
                                                                                    isDisabled={!!bookingUser}
                                                                                    placeholder="Select User"
                                                                                    id="ddlUser"
                                                                                    className="ddlUser"
                                                                                    options={dataList.map(c => ({
                                                                                        label: `${c.Name} (${c?.MembershipNo})`,
                                                                                        value: c.ID
                                                                                    }))}
                                                                                />
                                                                                </div>
                                                                                <div className="input-group-append" style={{zIndex: 0}}>
                                                                                    <button className="btn btn-secondary kt-select-reset" type="button" disabled={!!bookingUser} onClick={() => setGuestUserID(null)}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                                </div>                                                               
                                                                                </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {(guestUserID != null || (bookSheet.SubCategoryID != 5 && bookSheet.SubCategoryID != 8)) && (
                                                                <div id="GuestHolder" >
                                                                    <div className="form-group row">
                                                                        <label className="col-form-label col-lg-3">Guest</label>
                                                                        <div className="col-xl-6 col-lg-8">
                                                                            <div className="input-group">
                                                                                <div style={{width: "60%"}}  >
                                                                                <Select
                                                                                    value={selectedGuest?.Name ? { 
                                                                                        label: `${selectedGuest?.Name} (${selectedGuest?.Mobile})`, 
                                                                                        value: bookSheet?.UserID 
                                                                                    } : ''}
                                                                                    onChange={(event) => {
                                                                                        updateBookingDetails('UserID', event.value);
                                                                                        guestUserID ? updateBookingDetails('OwnerID', guestUserID) : 0;
                                                                                        setSubCatID(event.subCatID);
                                                                                    }} 
                                                                                    name="ddlGuest"
                                                                                    placeholder="Select Guest"
                                                                                    isDisabled={!!bookingUser}
                                                                                    id="ddlGuest"
                                                                                    data-live-search="true"
                                                                                    className="ddlGuest"
                                                                                    options={filteredList.map(c => ({
                                                                                        label: `${c.Name} (${c.Mobile})`,
                                                                                        value: c.ID,
                                                                                        subCatID: c.SubCategoryID
                                                                                    }))}
                                                                                />
                                                                                </div>
                                                                                <div className="input-group-append"  style={{zIndex: 0}}>
                                                                                    <button className="btn btn-secondary kt-select-reset" disabled={!!bookingUser}  type="button" onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                                </div>
                                                                                {!bookingUser && (
                                                                                    <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={() => addBookingUserHandler("guest")}>Add</button>
                                                                                )}            
                                                                                <button id="btnNewGuest" className="btn btn-label-brand margin-l10" disabled={!!bookingUser}  type="button" data-toggle="modal" data-target="#modalGuest"  onClick={() => setShowAddGuest(true)} >New</button>
                                                            
                                                                                </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            </>
                                                        )}
                                                    </>
                                                )} 
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Bucket</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <Select 
                                                            id="ddlBucket" 
                                                            name="ddlBucket"
                                                            isDisabled={bookSheet.ID != 0? "disabled" : ''}
                                                            className="multi-custom"
                                                            placeholder="Select Bucket"
                                                            defaultValue={ bookSheet?.Bucket && bucketOption.length > 0 && {label: `${bucketOption.find(m => m.label == bookSheet.Bucket).label}`, value: bookSheet.Bucket} || ''}
                                                            onChange={(event) => updateBookingDetails('Bucket', event.value)}
                                                            options={bucketOption}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Club Rental (1)</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <span className="kt-switch kt-switch--icon">
                                                            <label>
                                                                <input 
                                                                    id="chkActive" 
                                                                    name="chkActive" 
                                                                    disabled={bookSheet.ID != 0? "disabled" : ''}
                                                                    type="checkbox" 
                                                                    defaultChecked={bookSheet.Club != 1 ? '' : 'checked'} 
                                                                    onChange={(event) => updateBookingDetails('Club', event.target.checked ? 1 : 0)}
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-sm-3 text-right"> Discount %</label>
                                                    <div className="form-group col-6 input-group" style={{marginBottom: '1rem'}}>
                                                    <input 
                                                        id="txtDiscount" 
                                                        name="txtDiscount" 
                                                        type="text"                         // Use text to control leading zeros
                                                        inputMode="numeric"                // Brings up numeric keyboard on mobile
                                                        disabled={bookSheet.ID !== 0}
                                                        className="form-control"
                                                        value={bookSheet.Discount?.toString() || 0}
                                                        onChange={(event) => {
                                                            let value = event.target.value;

                                                            // Remove all non-digit characters
                                                            value = value.replace(/\D/g, '');

                                                            // Remove leading zeros (unless the value is just "0")
                                                            value = value.replace(/^0+(?!$)/, '');

                                                            // Convert to number for update
                                                            const numericValue = value === '' ? 0 : Number(value);

                                                            updateBookingDetails('Discount', numericValue);
                                                        }} 
                                                    />
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">
                                                                <i className="flaticon2-percentage"></i>                    
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Settle Mode</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div className="input-group" >
                                                            <div style={{width: "60%"}}  >
                                                                <Select
                                                                    value={(settlementList && settlementList.length > 0 && bookSheet.PaymentMode) && {label: bookSheet.PaymentMode, value: `${settlementList.find(m => m.Name == bookSheet.PaymentMode)?.ID}`} || ''}
                                                                    onChange={(event) => {updateBookingDetails('PaymentMode', event.label); updateBookingDetails('PaymentModeID', event.value)}}
                                                                    name="ddlMode"
                                                                    isDisabled={bookSheet.ID != 0? "disabled" : ''}
                                                                    placeholder="Select Mode"
                                                                    id="ddlMode"
                                                                    className="ddlMode"
                                                                    options={settlementList.map(c => ({
                                                                        label: c.Name,
                                                                        value: c.ID
                                                                    }))}
                                                                />
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Comment</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <textarea 
                                                            id="txtComment" 
                                                            name="txtComment" 
                                                            className="form-control" 
                                                            rows="3"
                                                            value={bookSheet.Comment || ''}
                                                            onChange={(event) => updateBookingDetails('Comment', event.target.value)} 
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </form>
                                            <table id="table-user" className="table table-bordered table-hover margin-b30">
                                                <thead className="light-grey-background">
                                                    <tr>
                                                        <th>Players</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                {bookingUser &&
                                                    <>
                                                        <tbody>
                                                            <tr>
                                                                {/* <td onClick={() => {paymentHandler(bookingUser)}}> */}
                                                                <td>
                                                                    <span className={`kt-badge kt-badge--${bookingUser.UserType == "User" ? 'success' : (bookingUser.UserType == "Guest" || bookingUser.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}>
                                                                    </span>&nbsp; &nbsp;{bookingUser.Name}&nbsp; &nbsp;
                                                                   <small style={{color: "Red"}}>{(bookingUser.IsSubscriptionExpires == "N" && bookingUser.IsValidMember == "N") ? "Subscription Expired!" : ''}</small>
                                                                </td>
                                                                <td>
                                                                <center>
                                                                        <button className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10 btn-user-delete" disabled={bookSheet?.ID > 0} type="button" onClick={deleteUserHandler} >                  
                                                                            <i className="flaticon2-rubbish-bin-delete-button"></i>             
                                                                        </button>
                                                                    </center>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr className="text-center">
                                                            <td colSpan="5">
                                                                <span>
                                                                <a
                                                                    id="lblGstNo"
                                                                    className="lbl text-center margin-0"
                                                                    href="#"
                                                                    data-toggle="modal"
                                                                    data-target="#modalCompany"
                                                                    onClick={() => setCompany(bookingUser.ID)}  
                                                                >
                                                                    {selectCompany?.ID ? `${selectCompany.CompanyName + ' : ' + selectCompany.GSTNumber}` : 'Add GST Number'}
                                                                </a>
                                                                </span>
                                                            </td>
                                                            </tr>
                                                        </tfoot>
                                                    </> 
                                                }
                                                <tfoot></tfoot>
                                            </table>
                                            <table id="table-tax" className="table table-bordered table-hover margin-b30" style={{ flex: 1 }}>
                                                    <thead className="light-grey-background">
                                                        <tr>
                                                            <th>Description</th>
                                                            <th className="text-right">Amount (₹)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rateDetails.GreenFee != 0 && rateDetails?.GreenFee && (
                                                            <tr>
                                                                <td>Green Fee </td>
                                                                <td className="text-right">₹ {rateDetails.GreenFee}</td>
                                                            </tr>   
                                                        )} 
                                                        {rateDetails.Bucket != 0 && (
                                                            <tr>
                                                            <td>{bookSheet.Bucket + ' Bucket'} </td>
                                                            <td className="text-right">₹ {rateDetails.Bucket}</td>
                                                        </tr>    
                                                        )} 
                                                        {bookSheet?.Club == 1 && (
                                                            <tr>
                                                                <td>Club</td>
                                                                <td className="text-right">₹ {rateDetails.Club}</td>
                                                            </tr>
                                                        )}
                                                        {rateDetails.Discount != 0 && (
                                                            <tr>
                                                                <td>Discount</td>
                                                                <td className="text-right">- ₹ {rateDetails?.Discount}</td>
                                                            </tr>
                                                        )}
                                                         <tr>
                                                            <td>SGST (9%)</td>
                                                            <td className="text-right">₹ {rateDetails?.Sgst}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CGST (9%)</td>
                                                            <td className="text-right">₹ {rateDetails?.Cgst}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Total</strong></td>
                                                            <td className="text-right"><strong>₹ {rateDetails.Total}</strong></td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot></tfoot>
                                            </table>
                                            <div className="row margin-bl5">
                                            <div className="col-sm-12 pl-0">
                                                <h6 className="margin-0 margin-b10" style={{color: '#535354', fontSize: '14px' }}>
                                                    <strong id="lblOwner">
                                                        {bookSheet?.ID && bookingUser.Name ? 'Booked By ' + (bookSheet.OwnerType == 'Admin' ? 'Admin' : bookSheet.OwnerName) : '' }
                                                        <div className='margin-b5'></div>
                                                        {bookSheet?.ID && bookingUser.Name ? `Tracking ID : ${bookSheet.TrackingID}` : ''}
                                                    </strong>
                                                </h6>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions">
                                                <div className="row">
                                                    <div className="col-lg-12 text-right">
                                                        {isValid && <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addBookingHandler}>{bookSheet.ID ? 'Update Booking' : 'Save Booking' }</button>}
                                                        {bookSheet && 
                                                            bookSheet.ID ? <>
                                                            <button id="btnInvoice" type="button" className="btn btn-warning d-inline-block margin-l10" onClick={viewForm}>Invoice</button> 
                                                            {isValid && <button id="btnCancel" type="button" className="btn btn-danger d-inline-block margin-l10" onClick={cancelBookingHandler}>Cancel Booking</button>} 
                                                            </> 
                                                            : ''
                                                        }
                                                        <button id="btnCloseDrawer" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </RightSideDetails>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {showAddGuest && (
                <AddGuest
                    show={showAddGuest}
                    onDismissModal={setShowAddGuest} 
                    fetchBookingDetails={() => fetchGuest()}
                    UserReferenceID={guestUserID}
                    from='mat'
                    bookingUserList={setBookingUser}
                    SubCategoryID={bookSheet.SubCategoryID}
                    guestUserID={guestUserID}
                    setBookSheet={setBookSheet}
                    setSubCatID={setSubCatID}
                    // setGuestList={setGuestList}
                    guestList={guestListRef}
                />
            )}
            {company && (
                <AddGSTNumber
                    show={company}
                    onDismissModal={setCompany} 
                    refID={company}
                    selectCompany={selectCompany}
                    setSelectCompany={setSelectCompany}
                />
            )}
        </>
    )
}

export default MatBookingSheet;